<template>
  <escalon-dialog
    :showModal="showDeleteModal"
    @close="closeModal"
    @modalConfirm="confirmDelete"
    @modalCancel="closeModal">
    <template slot="header">Delete Exam?</template>
    {{deleteText}}
  </escalon-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import escalonDialog from "./EscalonDialog";
export default {
  name: "DeleteExamDialog",
  components: {escalonDialog},
  computed: {
    ...mapGetters(["examToDelete", "examsToDelete"]),
    deleteText() {
      if (!this.examToDelete && this.examsToDelete.length <= 0) return "";
      else {
        if (this.examToDelete) {
          let exam = this.examToDelete;
          return `Mark exam ${exam.exDevice} dated ${exam.dateDisplay} as deleted?`;
        }
        else {
          return "Mark all selected exams as deleted?";
        }
      }
    },
    showDeleteModal(){
      return !!this.examToDelete || this.examsToDelete.length > 0;
    }
  },
  methods: {
    closeModal() {
      this.$store.commit("setExamToDelete", null);
      this.$store.commit("clearExamDeleteList");
    },
    confirmDelete() {
      if (this.examToDelete)
        this.$store
          .dispatch("removePatientExam", this.examToDelete.exSrNo)
          .then(() => this.$store.dispatch("getPatientExams"))
          .finally(this.closeModal);
      else {
        var promises = this.examsToDelete.map(e => this.$store.dispatch("removePatientExam", e.exSrNo));
        Promise.all(promises)
          .then(() => this.$store.dispatch("getPatientExams"))
          .finally(this.closeModal);
      }
    }
  }
}
</script>